import dayjs from 'dayjs';

class DateService {
  /* Format date eg. Monday, August 30, 2021 10:18 PM */
  public formatDate(dateValue: string | Date) {
    if (!dateValue) return null;
    return dayjs(dateValue).format('dddd, MMMM D, YYYY h:mm A');
  }
}

export default new DateService();
